module.exports = __webpack_public_path__ + "img/courier_1.e7c34db6.png";